export const addDataProducer = (dataProducer) => ({
  type: "ADD_DATA_PRODUCER",
  payload: { dataProducer },
});

export const removeDataProducer = (dataProducerId) => ({
  type: "REMOVE_DATA_PRODUCER",
  payload: { dataProducerId },
});
